import Vue from 'vue'
import Notify from './Index.vue'

const VueComponent = Vue.extend(Notify)

function show(text, time = 3000){
	const vm = new VueComponent({
		propsData: { text }
	})
	document.body.append(vm.$mount().$el)
	setTimeout(() => {
		vm.visible = false
		setTimeout(() => {
			vm.$destroy()
			document.body.removeChild(vm.$mount().$el)
		}, 300)
	},time)
}

export default show



